import { type FormEvent, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { adminApiClient } from "../../lib/adminApiClient";
import { setAdminSession, isAdminAuthed } from "../../lib/adminAuth";
import { describeError } from "../../components/States";

export function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (isAdminAuthed()) {
    return <Navigate to="/admin" replace />;
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);
    try {
      const session = await adminApiClient.login(username.trim(), password);
      setAdminSession(session.token, session.expiresAt);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(describeError(err));
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="stack" style={{ maxWidth: 360, margin: "80px auto 0" }}>
      <div>
        <h1>Admin sign in</h1>
        <p className="muted text-sm">Platform-operator dashboard. Not for buyer/seller accounts.</p>
      </div>
      <div className="card">
        <form className="stack" onSubmit={(e) => void handleSubmit(e)}>
          <div className="field">
            <label htmlFor="admin-username">Username</label>
            <input
              id="admin-username"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label htmlFor="admin-password">Password</label>
            <input
              id="admin-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && (
            <p className="field-error-text" role="alert">
              {error}
            </p>
          )}
          <button type="submit" className="btn btn-primary btn-block" disabled={isSubmitting}>
            {isSubmitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
